export default "__VITE_ASSET__dUG2x0dm__"